<template lang="">
    <div class="sideNav">
        <div class="side-nav-links">
        <button class="side-button" @click="showAddModal">
            <div class="icon-area plus-area">
                <PlusIcon/>
            </div>
            <div class="plus-area-text" style="margin-right:0.7rem;">Create Job</div>
        </button>
        <router-link title="Home" class="side-link" to="home">
            <div class="icon-area">
                <HomeIcon/>
            </div>
            <div>Home</div>
        </router-link>

        <router-link title="Vacancies" to="vacancies" class="side-link">
            <div class="icon-area">
                <BriefcaseIcon/>
            </div>
            <div>Vacancies</div>
        </router-link>
        <router-link title="Billing" to="/enterprise/billing" class="side-link">
            <div class="icon-area">
                <DollarSignIcon/>
            </div>
            <div>Billing</div>
        </router-link>
        <router-link title="Billing" to="/enterprise/about" class="side-link">
            <div class="icon-area">
                <InfoIcon style="height:1rem;margin-top:-0.1rem;margin-left:-0.05rem;"/>
            </div>
            <div style="margin-left:0.4rem;">About</div>
        </router-link>
         <router-link title="Privacy" to="/enterprise/privacy-policy" class="side-link">
            <div class="icon-area">
                <ShieldIcon/>
            </div>
            <div>Privacy</div>
        </router-link>
         <router-link title="Account Settings" to="/enterprise/my-account" class="side-link">
            <div class="icon-area">
                <SettingsIcon/>
            </div>
            <div>Settings</div>
        </router-link>
        
          <a title="Public Site" href="/" class="side-link" target="_blank">
            <div class="icon-area">
                <ArrowUpRightIcon/>
            </div>
            <div>Public</div>
        </a>
        <router-link title="Account Settings" to="/enterprise/contact-us" class="side-link">
            <div class="icon-area">
                <PhoneIcon style="height:1rem;margin-top:-0.1rem;margin-left:-0.05rem;"/>
            </div>
            <div style="margin-left:0.4rem;">Contact Us</div>
        </router-link>
       
         <button title="Sign Out" class="side-link signout" style="border:0px;background:transparent;" @click="logOut">
            <div class="icon-area">
                <LogOutIcon/>
            </div>
            <div>Sign Out</div>
        </button>
        
        </div>
        <CreateVacancyModal 
                modal-title="New Vacancy"
                save-button-label="Create Vacancy"
                ref="addVacModal"
                modal-id="createVac"
                :close-and-redirect="closeAndRedirect"/>
    </div>
</template>
<script>
import CreateVacancyModal from '@/components/modals/CreateVacancyModal.vue';
import BriefcaseIcon from '@/components/IconComponents/BriefcaseIcon.vue';
import UserCheckIcon from '@/components/IconComponents/UserCheckIcon.vue';
import UsersIcon from '@/components/IconComponents/UsersIcon.vue';
import SettingsIcon from '@/components/IconComponents/SettingsIcon.vue';
import LogOutIcon from '@/components/IconComponents/LogOutIcon.vue';
import FlagIcon from '@/components/IconComponents/FlagIcon.vue';
import DollarSignIcon from '@/components/IconComponents/DollarSignIcon.vue';
import ShieldIcon from '@/components/IconComponents/ShieldIcon.vue';
import ArrowUpRightIcon from '@/components/IconComponents/ArrowUpRightIcon.vue';
import PlusIcon from '@/components/IconComponents/PlusIcon.vue';
import HomeIcon from '@/components/IconComponents/HomeIcon.vue';
import InfoIcon from '@/components/IconComponents/InfoIcon.vue';
import PhoneIcon from '@/components/IconComponents/PhoneIcon.vue';
import store from '@/store';
export default {
    components:{
        CreateVacancyModal,
        BriefcaseIcon,
        UserCheckIcon,
        UsersIcon,
        SettingsIcon,
        LogOutIcon,
        FlagIcon,
        DollarSignIcon,
        ShieldIcon,
        ArrowUpRightIcon,
        PlusIcon,
        HomeIcon,
        InfoIcon,
        PhoneIcon

    },  
    methods:{
        logOut(){
            store.dispatch('auth/logout');
            this.$router.push({path:'/login',
                     query:{
                            message:"You have been logged out"
                        }
            });
        },
        navigateOrRefresh(route) {
            const targetRoute = route.startsWith('/') ? route : `/enterprise/${route}`;
            const currentRoute = this.$router.currentRoute.fullPath;
            if (currentRoute === targetRoute) {
                this.$router.go(0);
            } else {
                this.$router.push(route);
            }
        },
        closeAndRedirect(){
            this.closeAddModal();
            this.$router.push('/enterprise/vacancies');           
        },
         closeAddModal(){
        if (this.$refs.addVacModal && typeof this.$refs.addVacModal.hide === 'function') {
            this.$refs.addVacModal.hide();
        }
        },
        showAddModal(){
            this.$refs.addVacModal.show();
        },

    }
}
</script>
<style scoped>

    .plus-area{
        margin-top:-0.1rem;
        margin-right:0.2rem;
        color:var(--enterprise-button);
    }

     .plus-area-text{
        color:var(--enterprise-button);
    }

    .icon-img-sm{
        height:1rem;
        margin-top:-0.3rem;
        margin-right:0.4rem;
    }
    .side-link{
        display: flex;
        align-items: center;
        text-decoration: none;
        color:var(--sidenav-link);
        margin-bottom:0rem;
        padding-top:0.4rem;
        padding-bottom:0.4rem;
        padding-left:0.5rem;
        font-size:0.9rem;
    }

.icon-img{
    
    margin-top:-0.2rem;
    margin-right:0.3rem;
}

.side-button{
    color:white;
    display:flex;
    align-items: center;
    padding:0.4rem 0.6rem;
    border:0px;
    font-size:0.9rem;
    border-radius:100px;
    background: #3F5EFB;
    margin-top:0.8rem;
    margin-bottom:0.8rem;
    background: var(--page-header);
}

    .sideNav{
        max-width:14rem;
        min-width :10rem;
        padding-top:4rem;
        padding-left:0.8rem;
        padding-right:0.8rem;
        background-attachment: fixed;
        background: url("../../assets/images/vocation-icon-transparent.svg") no-repeat fixed -6% 108% / 17rem, var(--nav);
        box-shadow: 0 6px 18px rgba(0,0,0,0.06), 0 2px 6px rgba(0,0,0,0.04);
        display:grid;
    }

    .side-nav-links{
        position:fixed;
    }

    .side-nav-links  a.router-link-exact-active {
        color: var(--sidenav-link-active);
        border-left:2px solid var(--sidenav-link-active);
        padding-top:0.2rem;
        padding-bottom:0.2rem;
        padding-left:0.4rem;
        margin-top:0.2rem;
        margin-bottom:0.2rem;
    }

    .side-nav-links a:hover {
        color: var(--sidenav-link-active);
    }

      .signout:hover{
       color: var(--sidenav-link-active);
    }

    
</style>